import React from 'react';
import styled from 'styled-components';
import SwiperCore, {
  Navigation,
  Scrollbar,
  Mousewheel,
  Pagination,
  Thumbs,
  Keyboard,
} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import type { GallerySwiperProps } from './types';

import ImageComponent from './components/ImageComponent';
import VideoCover from './components/VideoCover';

SwiperCore.use([
  Navigation,
  Scrollbar,
  Mousewheel,
  Pagination,
  Thumbs,
  Keyboard,
]);

const GallerySwiper = ({
  images,
  video,
  isMobile,
  title,
  paramsSwiper,
  realIndexSlide,
  setSwiperGallery,
  isLooped,
  openPopup,
  thumbsSwiper,
  children,
  imageOnError,
}: GallerySwiperProps) => {
  const thumbsParam = {
    swiper: thumbsSwiper,
  };

  return (
    <>
      <StyledSwiper
        {...paramsSwiper}
        thumbs={thumbsParam}
        initialSlide={realIndexSlide}
        onSwiper={setSwiperGallery}
        isMobile={isMobile}
        isLooped={isLooped}
        className="swiper-container"
      >
        <div className="swiper-wrapper">
          {images.map((image, index) => (
            <SwiperSlide
              key={`slide-${image.id}`}
              onClick={() => openPopup?.(index, image.id)}
            >
              {!!video && index === 0 ? (
                <VideoCover title={title} coverImage={video.cover} />
              ) : (
                <ImageComponent
                  src={image.smallImage ?? ''}
                  title={title}
                  isLazyLoading={index > 6}
                  onError={imageOnError}
                />
              )}
            </SwiperSlide>
          ))}
        </div>
        {children}
      </StyledSwiper>
    </>
  );
};

const StyledSwiper = styled(Swiper)<{
  isMobile: boolean;
  isLooped?: boolean;
}>`
  height: 300px;
  cursor: pointer;
  .swiper-slide {
    width: auto;
    ${({ isMobile }) =>
      isMobile &&
      `
      width: 100%;
      height: 100%;
    `}
    img {
      height: 100%;
      ${({ isMobile }) =>
        isMobile &&
        `
        width: 100%;
        object-fit: cover;
      `}
    }
  }
  .swiper-pagination {
    color: #fff;
    ${({ isMobile }) => isMobile && 'margin-bottom: 8px;'}
  }
  .swiper-button-prev,
  .swiper-button-next {
    ${({ isMobile }) =>
      isMobile
        ? `
        bottom: 0px;
        height: 50px;
        margin: auto;
        width: 150px;
        transform: translate(0, 100%);
        `
        : `
        top: 0px;
        height: 100%;
        margin: auto;
        width: 50px;
        `}
  }
  ${({ isMobile }) =>
    isMobile &&
    `
  .swiper-button-prev {
    right: 30%;
  }
  .swiper-button-next {
    left: 30%;
  }
  `}
  ${({ isLooped }) =>
    isLooped &&
    `
    #always-active-button {
      opacity: 1;
      pointer-events: all;
      cursor: pointer;
    }
  `}
`;

export default GallerySwiper;
